import React from 'react';
import useAudioRoutingPageResource from './AudioRoutingPageResourceHook';
import useSpeechComfortTestStartPageHandler from '../Start/SpeechComfortTestStartPageHandlerHook';
import { ButtonType } from '../../../../SharedComponents/Button/ButtonType';
import CustomButton from '../../../../SharedComponents/Button/CustomButton';
import AppContainer from '../../../../SharedComponents/Container/AppContainer';
import BodyContainer from '../../../../SharedComponents/Container/BodyContainer';
import CustomImg from '../../../../SharedComponents/CustomImage/CustomImg';
import Header from '../../../../SharedComponents/Header/HeaderRefactor';
import './AudioRoutingPage.scss';
import CustomTypography, {
    TypographyType,
} from '../../../../SharedComponents/Typography/CustomTypography';

export default function AudioRoutingPage(): React.ReactElement {
    const { goToDetailPage, linkCallBacks } =
        useSpeechComfortTestStartPageHandler();
    const { header, image, instructionText, audioRoutingHelpLink, button } =
        useAudioRoutingPageResource();

    return (
        <AppContainer>
            <Header headerContent={header} />
            <BodyContainer>
                <CustomImg
                    imgType="small"
                    id={image.id}
                    src={image.src}
                    alt={image.alt}
                    className={'img-audio-routing'}
                />
                <CustomTypography
                    id={instructionText.id}
                    type={TypographyType.notoSansBody16px}
                    text={instructionText.text}
                    className={'instructionTextLeftAlign'}
                    linkCallBacks={linkCallBacks}
                />
                <CustomTypography
                    id={audioRoutingHelpLink.id}
                    type={TypographyType.notoSansBody16px}
                    text={audioRoutingHelpLink.text}
                    linkCallBacks={linkCallBacks}
                />
            </BodyContainer>
            <CustomButton
                buttonType={ButtonType.PrimaryLoading}
                id={button.id}
                onClick={async () => {
                    await goToDetailPage();
                }}
            >
                {button.label}
            </CustomButton>
        </AppContainer>
    );
}
